import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createImageHeaderComponent, ImageHeader } from '@vfde-brix/image-header';
import { SalesChannel } from '../enum';
import { getHeadline } from 'Helper/additionalPageOptionsHelper';

export const updateImageHeader = (comp: ImageHeader | null, salesChannel: SalesChannel, isFlex: boolean) => {
    const headlineData = getHeadline(salesChannel, isFlex);

    if (!comp || !headlineData) {
        return;
    }

    const props = comp?.getProperties();
    const { headline, subline, imageUrl } = headlineData;

    props.stdHeadline = headline;
    props.stdSubline = subline;

    if (imageUrl) {
        props.imgBackgroundDesktop = imageUrl.desktop;
        props.imgBackgroundMobile = imageUrl.mobile;
    }

    comp.update(props);
};

const mountImageHeader = (wrapperId: string) => {
    const container = document.getElementById(wrapperId);

    return container && createImageHeaderComponent(container, NO_PATTERN_BUSINESS_LOGIC);
};

export default mountImageHeader;
